
export default {
    name: 'rapport-versement',
    components: {},
    props: {
        rapport_versements: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, { key: 'montant', label: 'Montant' }, 
                'commentaire'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            versement_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshVersement()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshVersement() {
            if (this.rapport_versements) {
                this.versement_len = this.rapport_versements.length
            }
        }
    }
}